import React, { useCallback, useState } from 'react';
import Header from './components/site/Header';
import Hero from './components/site/Hero';
import Introduction from './components/site/Introduction';
import ExperienceSlider from './components/site/ExperienceSlider';
import StaySection from './components/site/StaySection';
import {
  DiningSection,
  WellnessSection,
  CelebrationsSection,
  ExploreSection,
  MeetingsSection,
  GiftsSection,
} from './components/site/Sections';
import FAQ from './components/site/FAQ';
import Footer from './components/site/Footer';
import BookingModal from './components/site/BookingModal';
import { Toaster } from './components/ui/toaster';
import './App.css';

const SiteContent = React.memo(({ onBook }) => (
  <>
    <Header onBook={onBook} />
    <main>
      <Hero onBook={onBook} />
      <Introduction onBook={onBook} />
      <ExperienceSlider />
      <StaySection onBook={onBook} />
      <DiningSection />
      <WellnessSection />
      <CelebrationsSection />
      <ExploreSection />
      <MeetingsSection />
      <GiftsSection />
      <FAQ />
    </main>
    <Footer />
  </>
));

function App() {
  const [bookOpen, setBookOpen] = useState(false);
  const openBook = useCallback(() => setBookOpen(true), []);
  const closeBook = useCallback(() => setBookOpen(false), []);

  return (
    <div className="App bg-white text-neutral-900">
      <SiteContent onBook={openBook} />
      <BookingModal open={bookOpen} onClose={closeBook} />
      <Toaster />
    </div>
  );
}

export default App;
